import { SortByDirection } from '../types/SortByDirection';
import { SortByType } from '../types/SortByType';

export const DirectionMap = {
  fromSortBy: (sortBy: SortByType): SortByDirection => {
    switch (sortBy) {
      case SortByType.CREATED_AT_ASCEND:
      case SortByType.UPDATED_AT_ASCEND:
        return 'asc';
      case SortByType.CREATED_AT_DESCEND:
      case SortByType.UPDATED_AT_DESCEND:
        return 'desc';
      default:
        return 'desc';
    }
  },
};
